import { render, staticRenderFns } from "./FlatsList.vue?vue&type=template&id=25482e07&lang=pug&"
import script from "./FlatsList.vue?vue&type=script&lang=ts&"
export * from "./FlatsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports